module.exports = __webpack_public_path__ + "img/checking.7b99b3e4.png";